import * as z from 'zod';

export const WORK_EMAIL_LABEL = 'Рабочая почта';
export const COMPANY_WEBSITE_LABEL = 'Сайт компании';
export const QUESTION_LABEL = 'Ваш вопрос?';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const workEmailSchema = z
  .string()
  .min(1, { message: 'Укажите рабочую почту' })
  .regex(emailRegex, { message: 'Введите корректный email' });

export const companyWebsiteSchema = z
  .string()
  .min(1, { message: 'Укажите сайт компании' })
  .refine((val) => /\./.test(val.trim()), {
    message: 'Укажите корректный адрес сайта',
  });

export const optionalQuestionSchema = z.string().max(2000).optional().or(z.literal(''));

export function normalizeCompanyWebsite(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}
